<template>
	<div class="col-md-12 col-sm-12 col-xs-12 text-left">
		<ul class="display-inline list-none topbar-contact">
			<li class="hidden-md hidden-sm hidden-xs">
				<a href="#newsletter-subscribe"><i class="fa fa-paper-plane"></i>{{ $t('Link.NewsletterSubscribe') }}</a>
			</li>
			<li class="hidden-xs">
				<router-link :to="{ name: 'contacts' }"><i class="fa fa-envelope"></i>{{ $t('Link.ContactUs') }}</router-link>
			</li>
			<li>
				<a :href="mailTo" target="_blank"> <i class="fa fa-share-alt"></i>{{ $t('Link.ReportToAFriend') }}</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'HeaderSupport',
	data() {
		return {
			mailTo:
				'mailto:?subject=' +
				this.$t('Sentence.ReportToAFriendSubject') +
				'&body=' +
				this.$t('Sentence.ReportToAFriendBody', { url: process.env.SITE_URL }),
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/components/header/HeaderSupport.vue